module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-SemiBoldItalic-f660659c43ea6fec8b536275b0d065f9.woff2";